import React from 'react';
import { BookOpen } from 'lucide-react';

const FreeTools: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-semibold text-[#103541] mb-2">
            Materiais Gratuitos
          </h2>
          <p className="text-[#2E6173] mb-8">
            Acesse nossa biblioteca completa de conteúdos, ferramentas e recursos para gestão fiscal
          </p>
          
          <a
            href="https://materiais.nfe.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white px-8 py-4 rounded-xl border border-gray-200 
              hover:border-[#7AEA53] hover:shadow-lg transition-all duration-300 group"
          >
            <BookOpen className="text-[#7AEA53] group-hover:scale-110 transition-transform" />
            <span className="font-medium text-[#103541]">
              Acessar Biblioteca de Materiais
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FreeTools;